import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormControl } from '@material-ui/core';
import styles from './styles';

function FormElement(props) {
    const { classes, ...other } = props;
    return (
        <FormControl className={classes.formElement} {...other}>
            {props.children}
        </FormControl>
    );
}

export default withStyles(styles)(FormElement);